import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spinner } from "@/components/ui/spinner";
import { useAuthStore } from "../stores/useAuthStore";

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const setAccessToken = useAuthStore((s) => s.setAccessToken);

  useEffect(() => {
    const at = searchParams.get("at");
    if (!at) {
      navigate("/login", { replace: true });
      return;
    }
    setAccessToken(at);
    // Clean token from URL before navigating
    navigate("/", { replace: true });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <span className="text-4xl">👻</span>
        <p
          role="status"
          className="flex items-center gap-2 text-muted-foreground text-sm font-sans"
        >
          <Spinner />
          Signing you in…
        </p>
      </div>
    </div>
  );
}
